// extracted by mini-css-extract-plugin
export default {"floatingActionButton":"FloatingActionButton_floatingActionButton__2P1Al"};